import { differenceInHours, differenceInMinutes, format } from 'date-fns';

/**
 * 最終提案日時の表示
 * - 1時間未満: "○分前"
 * - 24時間以内: "○時間前"
 * - それ以降: "yyyy年M月d日HH:mm"
 */
export function formatLastOfferedAt(dateInput: string | Date): string {
  const date = typeof dateInput === 'string' ? new Date(dateInput) : dateInput;

  if (isNaN(date.getTime())) return '';

  const now = new Date();
  const minutes = Math.max(differenceInMinutes(now, date), 0);
  if (minutes < 60) return `${minutes}分前`;

  const hours = Math.max(differenceInHours(now, date), 0);
  if (hours < 24) return `${hours}時間前`;

  return format(date, 'yyyy年M月d日HH:mm');
}
